import axiosInstance from "@/plugins/axios";

// Incidência por Natureza (Rubricas) — lista read-only servida pelo BFF a partir do
// CSV curado (CON-5210). Base = BFF (axiosInstance), não o parser.
const base = "configuracoes/rubricas/incidencia-natureza";

const ServiceIncidenciaNatureza = {
  /** @param {*} body @param {{ page?: number, size?: number, sort?: string, signal?: AbortSignal }} [opts] */
  search: (body, { page = 0, size = 50, sort, signal } = {}) =>
    axiosInstance.post(`${base}/search`, body ?? {}, {
      params: { page, size, ...(sort ? { sort } : {}) },
      ...(signal ? { signal } : {}),
    }),
  filters: () => axiosInstance.get(`${base}/filters`),
  exportData: (body) => axiosInstance.post(`${base}/export`, body ?? {}, { responseType: 'blob' }),
};

export default ServiceIncidenciaNatureza;
